<template>
  <div class="header__logos">
    <router-link
      class="header__logo"
      to="/"
    >
      <img
        :src="logoUrl"
        class="header__logo-pic"
        :alt="client"
      />
    </router-link>
  </div>
</template>

<script>
import { $i18n } from '@/shared/helpers/i18n';
import { useUiStore } from '@/shared/store/useUiStore';
import {
  computed,
  defineComponent,
} from 'vue';

export default defineComponent({
  setup() {
    const uiStore = useUiStore();
    const client = computed(() => uiStore.client);
    const currentLocale = computed(() => $i18n.locale);

    const logoUrl = computed(() => {
      return require('@/projects/mti/assets/img/header/logo-moi-capital.svg');
    });

    return {
      client,
      logoUrl,
    };
  },
});
</script>
